import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const { t } = useLang();
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sessionId = m ? decodeURIComponent(m[1]) : null;
    if (!sessionId) {
      setError("Missing session_id");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (data.token) localStorage.setItem("aqar_token", data.token);
        // Clear hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/app", { replace: true });
      } catch (err) {
        setError(formatApiError(err));
        toast.error(formatApiError(err));
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen grain-bg flex items-center justify-center p-4" data-testid="auth-callback-page">
      <div className="bg-white border border-[#E5E1D8] rounded-2xl p-8 shadow-sm text-center max-w-md">
        {!error ? (
          <>
            <div className="w-14 h-14 rounded-2xl bg-[#F3EFE7] text-[#2A5948] flex items-center justify-center mx-auto animate-pulse"><Loader2 size={28} /></div>
            <h2 className="mt-4 text-xl font-semibold">{t("verifying_payment")}</h2>
            <p className="text-sm text-[#5C6053] mt-1">{t("please_wait")}</p>
          </>
        ) : (
          <>
            <h2 className="text-xl font-semibold text-[#A85540]">{t("login_failed")}</h2>
            <p className="text-sm text-[#5C6053] mt-2">{error}</p>
            <button onClick={() => navigate("/login")} className="mt-6 brand-btn px-5 py-2.5 rounded-lg text-sm">{t("back_to_login")}</button>
          </>
        )}
      </div>
    </div>
  );
}
